<template>
    <ReactPage>
      <rt-las-link-report-page></rt-las-link-report-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "RtLasLinkReport",
    components: {
      ReactPage
    }
  }
  </script>